// extracted by mini-css-extract-plugin
export var active = "_cq-c";
export var compactArrow = "_cq-5";
export var container = "_cq-0";
export var dot = "_cq-b";
export var dotContainer = "_cq-a";
export var hoverArrowButton = "_cq-7";
export var hoverArrowContainer = "_cq-6";
export var leftHoverArrowContainer = "_cq-8 _cq-6";
export var rightHoverArrowContainer = "_cq-9 _cq-6";
export var slide = "_cq-4";
export var sliderContainer = "_cq-1";
export var sliderContainerVisibleOverflow = "_cq-2";
export var sliderOverflow = "_cq-3";
export var vignetteBoth = "_cq-f";
export var vignetteLeft = "_cq-e";
export var vignetteRight = "_cq-d";